import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useRef } from 'react';
import { getForgeUIExtensionsAsync } from '../../../provider/getForgeUIExtensionsAsync';
import { GQLExtensionContextsFilterType } from '../../../web-client';
import isEqual from 'lodash/isEqual';
import { fg } from '@atlaskit/platform-feature-flags';
var useCustomCompareMemo = function useCustomCompareMemo(factory, dependency, isEqual) {
  var dependencyRef = useRef(dependency);
  var valueRef = useRef(factory());
  if (!isEqual(dependency, dependencyRef.current)) {
    dependencyRef.current = dependency;
    valueRef.current = factory();
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(function () {
    return valueRef.current;
  }, [dependencyRef.current]);
};
var isSameDeps = function isSameDeps(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  var _a = _slicedToArray(a, 4),
    clientA = _a[0],
    appIdA = _a[1],
    environmentIdA = _a[2],
    contextIdsA = _a[3];
  var _b = _slicedToArray(b, 4),
    clientB = _b[0],
    appIdB = _b[1],
    environmentIdB = _b[2],
    contextIdsB = _b[3];
  return clientA === clientB && appIdA === appIdB && environmentIdA === environmentIdB && isEqual(contextIdsA.sort(), contextIdsB.sort());
};
export var useGetAppForgeUIExtensionsBase = function useGetAppForgeUIExtensionsBase(_ref) {
  var client = _ref.client,
    appId = _ref.appId,
    environmentId = _ref.environmentId,
    contextIds = _ref.contextIds;
  return useCustomCompareMemo(function () {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getForgeUIExtensionsAsync(_objectSpread({
                client: client,
                contextIds: contextIds,
                extensionsFilter: [{
                  type: GQLExtensionContextsFilterType.AppIdEnvironmentId,
                  value: "".concat(appId, ":").concat(environmentId)
                }]
              }, params));
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  }, [client, appId, environmentId, contextIds], isSameDeps);
};
export var useGetAppForgeUIExtensions = function useGetAppForgeUIExtensions(params) {
  var getAppForgeUIExtensions = useGetAppForgeUIExtensionsBase(params);
  return fg('forge-ui-navigation') ? getAppForgeUIExtensions : null;
};